import { useEffect, useState } from "react";
import axios from "axios";

const useGraphData = (endpoint, token) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get(endpoint, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then((response) => setData(response.data))
            .catch((error) => console.error("Error fetching data:", error))
            .finally(() => setLoading(false));
    }, [endpoint]);

    return { data, loading };
};

export default useGraphData;